import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import useLenis from "./hooks/useLenis";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Practice from "./components/Practice";
import Expertise from "./components/Expertise";
import Projects from "./components/Projects";
import Research from "./components/Research";
import Process from "./components/Process";
import ContactCTA from "./components/ContactCTA";
import Footer from "./components/Footer";
import ContactPage from "./pages/ContactPage";
import MerciPage from "./pages/MerciPage";

function Home() {
  useLenis();
  return (
    <div className="bg-[#F7F7F9] text-[#0A0A0A] min-h-screen antialiased selection:bg-[#D35400] selection:text-white">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Practice />
        <Expertise />
        <Projects />
        <Research />
        <Process />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/merci" element={<MerciPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
